/**
 * Khung chung cho màn Đăng nhập / Đăng ký — bố cục theo bản demo:
 * lockup Biadi ở giữa, câu dẫn, rồi tới nội dung form.
 */
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import logoFull from "statics/images/biadi-logo-full.png";

const TABS = [
  { value: "/auth/login", label: "ĐĂNG NHẬP" },
  { value: "/auth/register", label: "ĐĂNG KÝ" },
];

const AuthShell: React.FC<{
  /**
   * Tên của màn, hiện ngay dưới logo.
   *
   * Đăng nhập và đăng ký không cần: hai tab ngay bên dưới đã nói rõ đang ở đâu.
   * Những màn còn lại thì chỉ có logo Biadi và một câu dẫn, nên người dùng phải
   * đọc hết câu dẫn mới đoán ra mình đang ở màn gì.
   */
  title?: string;
  subtitle?: string;
  showTabs?: boolean;
  /**
   * Màn nhiều bước tự dựng nút quay lại của mình thì tắt cái này đi.
   *
   * Bật cả hai là trên cùng một màn có hai nút "Quay lại" làm hai việc khác
   * nhau: nút của màn thì lùi một bước, còn nút này rời hẳn trang về đăng nhập
   * và mất sạch những gì vừa gõ. Người dùng không có cách nào đoán được cái nào
   * làm gì.
   */
  showBack?: boolean;
  children: React.ReactNode;
  footer?: React.ReactNode;
}> = ({ title, subtitle, showTabs = true, showBack = true, children, footer }) => {
  const navigate = useNavigate();
  const { pathname, key } = useLocation();
  const activeTab = pathname.startsWith("/auth/register")
    ? "/auth/register"
    : "/auth/login";

  /* location.key === 'default' nghĩa là màn này là mục đầu tiên của phiên duyệt
     (mở thẳng bằng URL, hoặc vừa tải lại trang) — lúc đó không có gì để quay
     lại, đưa về trang chủ thay vì bấm mà không có phản ứng gì. */
  const goBack = () => {
    if (key === "default") {
      navigate("/");
      return;
    }
    navigate(-1);
  };

  return (
    <>
      {showBack ? (
        <button type="button" className="auth-back" onClick={goBack} aria-label="Quay lại">
          <span aria-hidden="true">‹</span> Quay lại
        </button>
      ) : null}

      <div className="auth-intro">
        <img src={logoFull} alt="Biadi" />
        {title ? <h1 className="auth-title">{title}</h1> : null}
        {subtitle ? <p>{subtitle}</p> : null}
      </div>

      {showTabs ? (
        <div className="seg" style={{ margin: "22px 8px 0" }}>
          {TABS.map((t) => (
            <button
              key={t.value}
              type="button"
              className={`seg-item${activeTab === t.value ? " active" : ""}`}
              onClick={() => navigate(t.value)}
            >
              {t.label}
            </button>
          ))}
        </div>
      ) : null}

      {children}

      {footer}
    </>
  );
};

export default AuthShell;
